
const Input = ({
  label,
  errors,
  name,
  touched,
  className,
  inputClassName,
  type,
  charCount,
  maxLength=30,  // Default maxLength value
  ...rest
}) => {
  return (
    <div className={`course-feilds position-relative ${className || "title-size"}`}>
      {label && <label>{label}</label>}
      <br />
      <input
        type={type}
        {...rest}
        maxLength={maxLength}
        className={inputClassName + " " + "input-bg" || ""}
      />
      {errors && <div className="error">{errors}</div>}

      {/* Character Count */}
      <div
        className="input-helpertext"
      >
      </div>
    </div>
  );
};

export default Input;